import React from 'react';
import clsx from 'clsx';
import { useCountUp } from '@/hooks/useCountUp';

type Props = {
  icon: React.ReactNode;
  label: string;
  value: number;
  /** Rendered after the number — e.g. a currency or unit. */
  format?: (n: number) => string;
  hint?: string;
  tone?: 'default' | 'warn' | 'danger' | 'success';
  delay?: number;
};

export const KpiCard: React.FC<Props> = ({ icon, label, value, format, hint, tone = 'default', delay = 0 }) => {
  const n = useCountUp(value);
  const shown = format ? format(n) : Math.round(n).toLocaleString();
  return (
    <div
      className="fade-up rounded-xl border border-border bg-surface p-4"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-center justify-between">
        <span className="text-2xs font-semibold uppercase tracking-[0.08em] text-text-muted">{label}</span>
        <span className={clsx(
          'flex h-7 w-7 items-center justify-center rounded-lg',
          tone === 'warn' ? 'bg-warning/15 text-warning'
            : tone === 'danger' ? 'bg-danger/15 text-danger'
              : tone === 'success' ? 'bg-success/15 text-success'
                : 'bg-primary/15 text-primary',
        )}>{icon}</span>
      </div>
      <div className={clsx(
        'mt-2 text-[26px] font-bold leading-none tabular-nums tracking-tight',
        tone === 'warn' ? 'text-warning' : tone === 'danger' ? 'text-danger' : 'text-text-primary',
      )}>
        {shown}
      </div>
      {hint && <div className="mt-1.5 text-2xs text-text-muted">{hint}</div>}
    </div>
  );
};
